export default __webpack_public_path__ + "static/media/games-btn-img.6ac04c11.svg";